// type
import { EventInput } from '@fullcalendar/core';
import { ExternalEvent } from './event.model';

export const calendarEvents: EventInput[] = [{
    id: '1',
    title: 'Meeting with Mr. Shreyu',
    start: new Date().setDate(new Date().getDate() + 1),
  classNames: 'bg-warning-subtle',

},
{
    id: '2',
    title: 'Interview - Backend Engineer',
    start: new Date(),
    end: new Date().setDate(new Date().getDate() + 1),
  classNames: 'bg-success-subtle',


},
{
    id: '3',
    title: 'Phone Screen - Frontend Engineer',
    start: new Date().setDate(new Date().getDate() + 8),
  classNames: 'bg-info-subtle',

},
{
    id: '4',
    title: 'Buy Design Assets',
    start: new Date().setDate(new Date().getDate() + 4),
  classNames: 'bg-primary-subtle',

}];


export const externalEvents: ExternalEvent[] = [
    {
        id: 1,
      title: 'Priority 4',
        type: 'success'
    },
    {
        id: 2,
      title: 'Priority 3',
      type: 'primary'
    },
    {
        id: 3,
      title: 'Priority 2',
        type: 'warning'
    },
    {
        id: 4,
      title: 'Priority 1',
        type: 'danger'
    },
];

